<template>
  <div class="certificate-container">
    <img class="certificate-img" src="../assets/popup-ngoi-sao-08-1000w.jpg" />
    <svg
      class="certificate-overlay-svg"
      width="100%"
      height="100%"
      viewBox="0 0 1000 1000"
      preserveAspectRatio="xMinYMin meet"
    >
      <svg:style>
        .fs-small {
          font-weight: bold;
          font-size: 24px;
        }
        .fs-large {
          font-weight: bold;
          font-size: 48px;
        }
        .c-red {
          fill: #d02d28;
        }
        .c-blue {
          fill: #181e5a;
        }
      </svg:style>

      <text x="500" y="640" class="c-blue fs-small" text-anchor="middle">Mạng lưới Thầy thuốc đồng hành cảm ơn</text>
      <text x="500" y="702" class="c-red fs-large" text-anchor="middle">{{ displayedRole }}: {{ displayedName }}</text>
      <text x="500" y="775" class="c-red fs-large" text-anchor="middle">Khu vực: {{ groupName }}</text>
      <text x="500" y="820" class="c-blue fs-small" text-anchor="middle">
        Đã thực hiện {{ countCall }} cuộc gọi, chăm sóc các bệnh nhân và người có
      </text>
      <text x="500" y="855" class="c-blue fs-small" text-anchor="middle">
        nguy cơ cao nhiễm COVID-19, trong ngày {{ displayedDate }}
      </text>
    </svg>
  </div>
</template>

<style scoped>
.certificate-container {
  position: relative;
}

.certificate-img {
  width: 100%;
}

.certificate-overlay-svg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>

<script>
export default {
  props: {
    displayedRole: {type: String},
    displayedName: {type: String},
    groupName: {type: String},
    countCall: {type: Number},
    displayedDate: {type: String},
  },
};
</script>
